export const Log = () => {
    const args = Array.prototype.slice.call(arguments);

    if (typeof args[0] === 'string') {
        args[0] = '%c' + args[0];
        args.splice(1, 0, 'color: #f00');
    }

    console.log.apply(console, args);
}